import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconButton } from '../buttons';
import styled from '../../styles/styled';
export const Container = styled('div')(({ theme }) => ({
    position: 'relative',
    width: '80vw',
    maxHeight: '60vh',
    height: '60vh',
    display: 'flex',
    flexDirection: 'column',
    padding: `
        ${theme.space[5]}px
        ${theme.space[5]}px`,
    background: theme.colors.white,
    boxShadow: theme.shadow.large,
    overflow: 'auto',
    borderRadius: '4px',
}));
export const NotesHeader = styled('div')({
    width: '100%',
    height: '50px',
    display: 'flex',
    justifyContent: 'space-between',
});
export const TextAreaContainer = styled('div')(({ theme }) => ({
    width: '100%',
    flex: '1 1 auto',
    padding: `${theme.space[4]}px 0`,
}));
export const TextArea = styled('textarea')(({ theme }) => ({
    width: '100%',
    height: '100%',
    fontSize: theme.text.size.medium,
    padding: theme.space[3],
    fontFamily: theme.text.bodyFontFamily,
    backgroundColor: theme.colors.grey05,
    border: `2px solid ${theme.colors.grey05}`,
    borderRadius: theme.radii[1],
    resize: 'none',
    outline: 'none',
    overflowY: 'scroll',
}));
export const NotesFooter = styled('div')({
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
});
export const CloseButton = (props) => (_jsx(IconButton, { iconName: "CloseIcon", size: "medium", shape: "circle", label: "close", onClick: props.onClick, background: "azure", fill: "white", "data-testid": props.id, type: "button" }));
//# sourceMappingURL=in_call_notes_styles.js.map